import type {
  AllowedStatesDataShort,
  AllowedStatesResponse,
  AllowedStatesResponseData
} from '@library/types/allowedStates';
import type { SelectOption } from '@library/types/utils';
import { formatDate } from '@library/component-utils/dateTime';

export const transformAllowedStateData = (
  response: AllowedStatesResponse | undefined
): Array<AllowedStatesDataShort> => {
  return response?.data.map((allowedState: AllowedStatesResponseData) => {
    return {
      id: allowedState.id,
      name: allowedState.attributes.name,
      createdAt: formatDate({ date: allowedState.attributes.created_at }),
      updatedAt: formatDate({ date: allowedState.attributes.updated_at })
    };
  }) as Array<AllowedStatesDataShort>;
};

export const transformAllowedStateOptions = (
  allowedStates: Array<AllowedStatesDataShort>
): Array<SelectOption> => {
  return allowedStates?.map((allowedState) => ({
    name: allowedState.name,
    value: allowedState.id,
    key: allowedState.id
  }));
};
